export const PostAuthLayoutWidth = '90vw';
export const TopAppBarHeight = '79px';
